<template>
  <svg width="49" height="50" viewBox="0 0 49 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.379883" width="49" height="49" rx="24.5" fill="#2F2F2F" />
    <path
      d="M24.5003 10.2964C32.5649 10.2964 39.0837 16.8151 39.0837 24.8797C39.0837 32.9443 32.5649 39.4631 24.5003 39.4631C16.4357 39.4631 9.91699 32.9443 9.91699 24.8797C9.91699 16.8151 16.4357 10.2964 24.5003 10.2964ZM29.7357 17.5881L24.5003 22.8235L19.2649 17.5881L17.2087 19.6443L22.4441 24.8797L17.2087 30.1151L19.2649 32.1714L24.5003 26.936L29.7357 32.1714L31.792 30.1151L26.5566 24.8797L31.792 19.6443L29.7357 17.5881Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: 'CancelProjectIcon'
}
</script>
